module.exports = __webpack_public_path__ + "img/EducationalGroups.b623ac90.svg";